// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2k45T","content":"styles_content__3TP8Q"};